module.exports = __webpack_public_path__ + "img/icon_error404.7b1c848a.svg";